/**
 * 包括契約検索API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 包括対象需給契約情報
 */
export interface Sgkb702aResInclusiontargetDemandctrinfoDto {
    /** 
     * 包括契約内需給契約通番号：数字
     */
    inclusioncontractSupplydemandcontractSrno?: string;
    /** 
     * 割引・割増開始日：日付(yyyyMMdd)
     */
    discountextraStartdate?: string;
    /** 
     * 割引・割増解除日：日付(yyyyMMdd)
     */
    discountextraUnlockdate?: string;
    /** 
     * 割引・割増金額：数字
     */
    discountextraMny?: number;
    /** 
     * 割引・割増率：数字
     */
    discountextraRate?: number;
    /** 
     * 契約お客さま番号：数字
     */
    firstSrvctrNo?: string;
    /** 
     * お客さま漢字氏名：全角
     */
    visitName?: string;
    /** 
     * 都道府県名称：全角
     */
    description?: string;
    /** 
     * 市区郡町村名称：全角
     */
    mptAname?: string;
    /** 
     * 町域名称：全角
     */
    townAreaName?: string;
    /** 
     * 大字丁目名称：全角
     */
    ooazaName?: string;
    /** 
     * 丁目番地以下漢字テキスト：全角
     */
    chomeanameIkaKanjitext?: string;
    /** 
     * 分筆号漢字テキスト（未使用）：全角
     */
    bunptgouKanjiText?: string;
    /** 
     * 住宅・棟号漢字テキスト：全角
     */
    supadrKanjiAname1?: string;
    /** 
     * 屋号・業種・目標（漢字）：全角
     */
    yagouAname?: string;
    /** 
     * エネルギー種別コード：数字
     */
    energyClscode?: string;
    /** 
     * エネルギー種別コード名称：全半角混在
     */
    energyClsfyCodeaname?: string;
    /** 
     * 熱量：英数字
     */
    heat?: string;
    /** 
     * 熱量名称：全半角混在
     */
    heatAname?: string;
    /** 
     * サービス契約解約日付：日付(yyyyMMdd)
     */
    prdBreakDate?: string;
    /** 
     * プロダクトコード：数字
     */
    prdCode?: string;
    /** 
     * プロダクト商品略称名称：全角
     */
    prdGoodsRyaku?: string;
    /** 
     * 供給地点特定番号：数字
     */
    suppntSpno?: string;
    /** 
     * 初回検針予定日：日付(yyyyMMdd)
     */
    firstKenshinscheduledate?: string;
    /** 
     * 使用お客さま番号：数字
     */
    logicDeviceNo?: string;
    /** 
     * 内部お客さま番号：数字
     */
    visitNo?: string;
    /** 
     * 請求お客さま番号：数字
     */
    recptFixNo?: string;
    /**
     * 送配電事業者コード
     */
    transCode?: string;
    /**
     * 送配電事業者コード名称
     */
    transCodeAname?: string;
    /**
     * 検針日区分
     */
    ksdateDiv?: string;
    /**
     * 検針日区分名称
     */
    ksdateDivAname?: string;
    /**
     * 基本検針日
     */
    basicKensinDay?: string;
    /**
     * 導管事業者コード
     */
    cndtBusCode?: string;
    /**
     * 導管事業者名称
     */
    cndtBusAname?: string;
    /**
     * 指定日検針日区分コード
     */
    siteiKensinDiv?: string;
    /**
     * 指定日検針日区分コード名称
     */
    siteiKensinDivAname?: string;
    /**
     * 検針日程
     */
    kensinSchdl?: string;
}
